import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    connect () {
        setTimeout(() => {
            this.element.showModal();
        }, 500);
    }

    close () {
        this.element.close();
    }
}
